import axios from 'axios'
import { DOCUMENTOS } from '../conexiones';
import { allDocumentos, documentoId, documentoNew, deleteDocumento, putDocumento } from './documentosSlice';
import {putArmadoEntregado} from './documentosSlice'

export const getAllDocumentos = () => {
    return async (dispatch) => {
        try {
            await axios.get(DOCUMENTOS)
            .then(res => dispatch(allDocumentos(res.data)))            
        } catch (error) {
            console.log(error);            
        }        
    }
}

export const getDocumentoId = (id) => {
    return async (dispatch) => {
        try {
            await axios.get(`${DOCUMENTOS}/${id}`)
            .then(res => dispatch(documentoId(res.data)))            
        } catch (error) {
            console.log(error);            
        }        
    }
}

export const postDocumento = (payload) => {
    console.log(payload);
    
    return async (dispatch) => {
        try {
            await axios.post(DOCUMENTOS, payload)
            .then(res => dispatch(documentoNew(res.data)))
        } catch (error) {
            console.log(error);            
        }
    }
}

export const documentoDelete = (id) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${DOCUMENTOS}/${id}`)
            .then(res => dispatch(deleteDocumento(res.data)))            
        } catch (error) {
            console.log(error);            
        }        
    }
}

export const armadoEntregado = (payload) => {
    console.log(payload);
    
    return async (dispatch) => {
        try {
            await axios.put(`${DOCUMENTOS}/armadoEntregado/${payload.id}`, payload)
            .then(res => dispatch(putArmadoEntregado(res.data)))
        } catch (error) {
            console.log(error);            
        }
    }
}

export const documentoPut = (id, payload) => {
    console.log(id, payload);
    
    return async (dispatch) => {
        try {
            await axios.put(`${DOCUMENTOS}/${id}`, payload)
            .then(res => dispatch(documentoPut(res.data)))
        } catch (error) {
            console.log(error);            
        }
    }
}